import React from "react";
import { Download, FileText, Clock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Reveal } from "./common";

export const FlyerDownload = () => {
  const { t, i18n } = useTranslation();
  const suffix = i18n.language === "fr" ? "-fr" : "";
  const FLYERS = [
    { id: "color", label: t("flyer.colorLabel"), sub: t("flyer.colorSub"), href: `/downloads/hepcure-flyer-color${suffix}.pdf`, file: `hepcure-flyer-color${suffix}.pdf`, testId: "flyer-download-color" },
    { id: "bw",    label: t("flyer.bwLabel"),    sub: t("flyer.bwSub"),    href: `/downloads/hepcure-flyer-bw${suffix}.pdf`,    file: `hepcure-flyer-bw${suffix}.pdf`,    testId: "flyer-download-bw" },
  ];
  return (
  <section
    data-testid="flyer-download-section"
    className="py-10 sm:py-16 bg-brand-offwhite relative overflow-hidden"
  >
    <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-12 gap-8 lg:gap-10 items-center">
        {/* Left copy */}
        <Reveal className="lg:col-span-6">
          <span className="inline-flex items-center gap-2 rounded-full bg-brand-teal/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-brand-teal-dark">
            <Clock className="h-3.5 w-3.5" strokeWidth={2} />
            {t("flyer.kicker")}
          </span>
          <h2 className="mt-4 text-2xl sm:text-3xl lg:text-4xl font-bold font-heading text-brand-navy leading-tight">
            {t("flyer.titleLead")}
            <br />
            <span className="text-brand-teal whitespace-pre-line md:whitespace-normal">
              {t("flyer.titleAccent")}
            </span>
          </h2>
          <p className="mt-4 text-slate-600 text-base sm:text-lg leading-relaxed max-w-xl whitespace-pre-line md:whitespace-normal text-justify md:text-left hyphens-auto">
            {t("flyer.body")}
          </p>
        </Reveal>

        {/* Right download cards */}
        <Reveal delay={0.1} className="lg:col-span-6 grid grid-cols-2 gap-3 sm:gap-4">
          {FLYERS.map((f) => (
            <a
              key={f.id}
              href={f.href}
              download={f.file}
              data-testid={f.testId}
              className="group flex flex-col justify-between rounded-2xl bg-white border border-gray-100 p-4 sm:p-6 shadow-sm hover:shadow-md transition-all duration-200 hover:-translate-y-1"
            >
              <div>
                <div className="h-10 w-10 sm:h-11 sm:w-11 rounded-xl bg-brand-teal/10 flex items-center justify-center text-brand-teal">
                  <FileText className="h-5 w-5" strokeWidth={1.8} />
                </div>
                <p className="mt-3 sm:mt-4 text-base sm:text-lg font-heading font-bold text-brand-navy leading-tight">
                  {f.label}
                </p>
                <p className="mt-1 text-xs sm:text-sm text-slate-500">{f.sub}</p>
              </div>
              <div className="mt-4 sm:mt-6 inline-flex items-center gap-2 text-brand-teal font-semibold text-sm">
                {t("flyer.download")}
                <Download className="h-4 w-4 transition-transform group-hover:translate-y-0.5" />
              </div>
            </a>
          ))}
        </Reveal>
      </div>
    </div>
  </section>
  );
};

export default FlyerDownload;
